import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _merge from "lodash/merge";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import classnames from 'classnames';
import { Container } from "../../Container/Container/Container";
import { SliceIntroBlock, defaultPropsSliceIntroBlock } from "../../Block/SliceIntroBlock/SliceIntroBlock";
import { Background } from "../../Background/Background";
import { Table } from "../../Table/Table";
import { Text } from "../../Text/Text/Text";
import styles from "./TableSlice.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var tableSliceAlign = ['left', 'center'];
export var TableSlice = function TableSlice(_ref) {
  var _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'center' : _ref$align,
    _ref$background = _ref.background,
    background = _ref$background === void 0 ? {
      color: 'none',
      theme: 'lightBackground'
    } : _ref$background,
    _ref$intro = _ref.intro,
    intro = _ref$intro === void 0 ? defaultPropsSliceIntroBlock : _ref$intro,
    _ref$table = _ref.table,
    table = _ref$table === void 0 ? {} : _ref$table,
    _ref$footnote = _ref.footnote,
    footnote = _ref$footnote === void 0 ? '' : _ref$footnote;
  var theme = background && background.theme ? background.theme : 'lightBackground';
  var backgroundData = _merge(background, {
    height: 0
  });
  var tableData = _merge(table, {
    attributes: {
      theme: theme
    }
  });
  var introData = _merge(intro, {
    align: align
  });
  return /*#__PURE__*/_jsx(Background, _objectSpread(_objectSpread({}, backgroundData), {}, {
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.wrapper,
      children: [/*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(SliceIntroBlock, _objectSpread({}, introData))
        })
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(Table, _objectSpread({}, tableData))
      }), /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsx("div", {
          children: footnote && /*#__PURE__*/_jsx(Text, {
            className: classnames({
              [styles.footer]: true,
              [styles.alignLeft]: align === 'left',
              [styles.alignCenter]: align === 'center'
            }),
            typog: "bodycopySmall",
            richText: true,
            children: footnote
          })
        })
      })]
    })
  }));
};